import { useCallback } from 'react';
import { PAGINATION_STEP } from '../../common';
import { PaginationStepRoot } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const PaginationStep = ({
  autoplay,
  hidden,
  isActive,
  isNext,
  isPrevious,
  pagination,
  slideIndex,
  onPaginationStepClick,
  renderPaginationStep
}) => {
  const onClick = useCallback(() => {
    onPaginationStepClick?.(slideIndex);
  }, [onPaginationStepClick, slideIndex]);
  if (renderPaginationStep) {
    return renderPaginationStep({
      autoplay,
      hidden,
      isActive,
      isNext,
      isPrevious,
      pagination,
      slideIndex,
      onPaginationStepClick: onClick
    });
  }
  return /*#__PURE__*/_jsx(PaginationStepRoot, {
    autoplay: autoplay,
    className: isActive ? 'active-pagination-step' : undefined,
    "data-testid": PAGINATION_STEP,
    hidden: hidden,
    isActive: isActive,
    isNext: isNext,
    isPrevious: isPrevious,
    pagination: pagination,
    onClick: onClick
  });
};
//# sourceMappingURL=PaginationStep.js.map